import { useState, useEffect } from "react";
import { xs, sm, md } from "@Src/ScreenSize";

export interface ResponsiveScreenSizes {
    isXxs: boolean;
    isXs: boolean;
    isSm: boolean;
    isMd: boolean;
}

const useResponsiveScreen = (): ResponsiveScreenSizes => {
    const [isXxs, setIsXxs] = useState(window.innerWidth < xs);
    const [isXs, setIsXs] = useState(
        window.innerWidth >= xs && window.innerWidth < sm
    );
    const [isSm, setIsSm] = useState(
        window.innerWidth >= sm && window.innerWidth < md
    );
    const [isMd, setIsMd] = useState(window.innerWidth >= md);

    useEffect(() => {
        const handleResize = (): void => {
            setIsXxs(window.innerWidth < xs);
            setIsXs(window.innerWidth >= xs && window.innerWidth < sm);
            setIsSm(window.innerWidth >= sm && window.innerWidth < md);
            setIsMd(window.innerWidth >= md);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return { isXxs, isXs, isSm, isMd };
};

export default useResponsiveScreen;
